import React from 'react';
import type { Props as SelectProps } from 'react-select';
import MaterialIcon from '../../icon/Icon.material';
import { GLOBAL_ICONS } from '../../../util/vars';
import { SELECTOR_ICON_DROPDOWN } from '../../../util/data-id';

const CustomDropdownIndicator: React.FC<SelectProps> = ({ size, ...props }) => {
  const {
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div {...restInnerProps} ref={ref} className={'cursor-pointer'}>
      <MaterialIcon data-selector={SELECTOR_ICON_DROPDOWN} icon={GLOBAL_ICONS.toggle_off} size={size} color={'dark'} />
    </div>
  );
};

export default CustomDropdownIndicator;
